import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import toast from "react-hot-toast";
import useStore from "../store/useStore";
import { openCashfreeSubscription } from "../utils/cashfree";
import StartSubscriptionPage from "./Account/sections/subscriptions/StartSubscriptionPage";
import {
  mapDeliverySlots,
  mapFrequencies,
  mapPaymentMethods,
  mapPlans,
  mapQuantities,
} from "./Account/sections/subscriptions/subscriptionUtils";

const SubscriptionStartPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const {
    isAuthenticated,
    openAuthModal,
    subscription_config,
    subscription_config_loading,
    subscription_products,
    subscription_products_loading,
    subscription_action_loading,
    user_addresses,
    fetchSubscriptionConfig,
    fetchUserAddresses,
    createSubscription,
    getSubscriptionMandateCheckout,
    fetchSubscriptions,
  } = useStore();

  useEffect(() => {
    fetchSubscriptionConfig();
  }, [fetchSubscriptionConfig]);

  useEffect(() => {
    if (isAuthenticated) fetchUserAddresses();
  }, [fetchUserAddresses, isAuthenticated]);

  const handleCreate = async (form) => {
    try {
      const { subscription, raw } = await createSubscription(form);
      if (form.payment_method === "upi_autopay") {
        const mandateCheckout = getSubscriptionMandateCheckout({
          ...raw,
          subscription_id: subscription.subscription_id,
        });
        if (subscription.subscription_id) {
          window.sessionStorage.setItem(
            "pending_subscription_mandate_id",
            String(subscription.subscription_id),
          );
        }
        await openCashfreeSubscription(mandateCheckout);
        return;
      }
      toast.success("Subscription activated successfully");
      await fetchSubscriptions();
      navigate("/account/subscriptions", { replace: true });
    } catch (error) {
      toast.error(error.message || "Failed to activate subscription");
    }
  };

  if (!isAuthenticated) {
    return (
      <div className="flex min-h-[65vh] items-center justify-center px-4 py-12">
        <div className="w-full max-w-md rounded-3xl border border-gray-100 bg-white p-8 text-center shadow-sm">
          <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-primary-50 text-2xl">🥛</div>
          <h1 className="mt-4 text-2xl font-black text-gray-900">Sign in to subscribe</h1>
          <p className="mt-2 text-sm leading-6 text-gray-500">Sign in first so we can save your delivery address and subscription schedule.</p>
          <button type="button" onClick={openAuthModal} className="mt-6 w-full rounded-xl bg-primary-600 px-5 py-3 text-sm font-extrabold text-white hover:bg-primary-700">Login / Sign up</button>
          <button type="button" onClick={() => navigate("/account/subscriptions")} className="mt-3 text-sm font-bold text-gray-500 hover:text-gray-800">Back to subscriptions</button>
        </div>
      </div>
    );
  }

  return (
    <StartSubscriptionPage
      products={subscription_products}
      addresses={user_addresses}
      plans={mapPlans(subscription_config?.plans || [])}
      quantityOptions={mapQuantities(subscription_config?.quantities || [])}
      frequencies={mapFrequencies(subscription_config?.frequencies || [])}
      deliverySlots={mapDeliverySlots(subscription_config?.delivery_slots || [])}
      paymentMethods={mapPaymentMethods(subscription_config?.payment_methods || [])}
      initialProductId={searchParams.get("productId") || ""}
      initialVariantId={searchParams.get("variantId") || ""}
      productsLoading={subscription_products_loading}
      loading={subscription_action_loading || subscription_products_loading || subscription_config_loading}
      onSubmit={handleCreate}
    />
  );
};

export default SubscriptionStartPage;
